module.exports = __webpack_public_path__ + "static/media/DSC_7360.c688bed4.jpg";